<template lang="pug">
  .base-date-select
    .d-flex
      b-btn(@click="previousMonth" :disabled="!previousMonthIsValid" variant="outline-light")
        font-awesome-icon(:icon="['fas', 'angle-left']")
      b-btn(@click="nextMonth" :disabled="!nextMonthIsValid" variant="outline-light")
        font-awesome-icon(:icon="['fas', 'angle-right']")
      b-form-select.select-month(v-model="month" :options="monthOptions" @change="setMonth")
      b-form-select.select-year(v-model="year" :options="yearOptions" @change="setYear")
</template>

<script>
export default {
  props: {
    value: String,
    minDate: {
      type: String,
      default: '01-01-2010'
    },
    maxDate: {
      type: String,
      default: 'now'
    },
    format: {
      type: String,
      default: 'DD-MM-YYYY'
    }
  },
  data () {
    return {
      date: this.$moment().date(1),
      month: this.$moment().month(),
      year: this.$moment().year()
    }
  },
  methods: {
    onSelect () {
      this.validate()
      this.$emit('input', this.getFormatedDate())
      this.$emit('change', this.getFormatedDate())
    },
    setMonth (month) {
      this.date.month(month)
      this.onSelect()
    },
    setYear (year) {
      this.date.year(year)
      this.onSelect()
    },
    nextMonth () {
      this.date.add(1, 'M')
      this.onSelect()
    },
    previousMonth () {
      this.date.subtract(1, 'M')
      this.onSelect()
    },
    getFormatedDate () {
      return this.date.format(this.format)
    },
    updateSelect () {
      this.year = this.date.year()
      this.month = this.date.month()
    },
    validate () {
      const year = this.date.year()
      const month = this.date.month()
      if (year > this.maxYear){
        this.date.year(this.maxYear)
      } else if (year < this.minYear) {
        this.date.year(this.minYear)
      }
      if (year === this.maxYear && month > this.maxMonth){
        this.date.month(this.maxMonth)
      } else if (year === this.minYear && month < this.minMonth) {
        this.date.month(this.minMonth)
      }
      this.updateSelect()
    }
  },
  computed: {
    yearOptions () {
      const options = []
      for (let i = this.maxYear; i >= this.minYear; i--) {
        options.push(i)
      }
      return options
    },
    monthOptions () {
      const options = []
      for (let i = this.minMonth; i <= this.maxMonth; i++) {
        options.push({ value: i, text: this.$moment().month(i).format('MMMM') })
      }
      return options
    },
    maxYear () {
      if (this.$moment(this.maxDate, this.format).isValid()) {
        return this.$moment(this.maxDate, this.format).year()
      } else {
        return this.$moment().year()
      }
    },
    minYear () {
      if (this.$moment(this.minDate).isValid()) {
        return this.$moment(this.minDate).year()
      } else {
        return this.$moment().year()
      }
    },
    maxMonth () {
      if (this.year === this.maxYear) {
        if (this.$moment(this.maxDate, this.format).isValid()) {
          return this.$moment(this.maxDate, this.format).month()
        }
        return this.$moment().month()
      }
      return 11
    },
    minMonth () {
      if (this.year === this.minYear) {
        if (this.$moment(this.minDate, this.format).isValid()) {
          return this.$moment(this.minDate, this.format).month()
        }
        return this.$moment().month()
      }
      return 0
    },
    nextMonthIsValid () {
      if (this.year === this.maxYear && this.month >= this.maxMonth) {
        return false
      }
      return true
    },
    previousMonthIsValid () {
      if (this.year === this.minYear && this.month <= this.minMonth) {
        return false
      }
      return true
    }
  },
  created () {
    if (this.$moment(this.value, this.format).isValid()) {
      this.date = this.$moment(this.value, this.format)
    }
    this.onSelect()
  }
}
</script>

<style lang="scss" scoped>
.base-date-select {
  display: inline-block;
  .select-month {
    margin-right: 0.75rem;
  }
  .select-year {
    text-transform: capitalize;
  }
  .btn {
    margin: 0 12px 0 0;
    color: var(--primary);
    width: 32px;
    border-color: #E4E4E4;
  }
}
</style>